import React from 'react'
import storage from 'util/storage'

export default class ImpersonationBar extends React.Component {
  render() {
    const auth = storage.get('auth')
    const isImpersonating = auth && auth.previousToken

    if (!isImpersonating) return null

    return <div className="impersonation-bar">Impersonating</div>
  }
}
